import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {PageViewModel} from '@components/ui/table-template/models/page-view-model';
import {InvoiceDetailsViewModel} from '../view-models/invoice-detail-view.model';

@Component({
    selector: 'app-invoice-details-card',
    templateUrl: './invoice-details-card.component.html',
    styleUrls: ['./invoice-details-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceDetailsCardComponent {
    public readonly currentPage = input.required<PageViewModel<InvoiceDetailsViewModel>>();
    public readonly buttonClicked = output<InvoiceDetailsViewModel>();

}
